import React, { useState } from 'react';
import DetailIcon from '@/common/detail-icon';
import classNames from 'classnames';
import doLog from '@/common/log';
interface PropType {
  title: string;
  children: React.ReactElement;
  abtest: DetailTypes.Abtest;
  logInfo: string;
}

export default function Collapsible({ abtest, title, children, logInfo }: PropType) {
  const [shown, setShown] = useState(false);
  // 是否命中商详折叠实验
  const isHidden = abtest.pc_detail_hidden_information === 'hidden';

  const showFloor = () => {
    doLog(`/sc.detail.${logInfo}_expand`, '', 'CLK');
    setShown(!shown);
  };

  const hideFloor = () => {
    doLog(`/sc.detail.${logInfo}_hide`, '', 'CLK');
    setShown(!shown);
  };

  return (
    <>
      <h3 className="collapsible-title">
        {title}
        {isHidden &&
          (shown ? (
            <DetailIcon onClick={hideFloor} symbol={'icon-up'} className={'detail-symbol'} />
          ) : (
            <DetailIcon onClick={showFloor} symbol={'icon-down'} className={'detail-symbol'} />
          ))}
      </h3>
      <div
        className={classNames({
          'collapsible-layout': true,
          hidden: !shown && isHidden,
        })}
      >
        {children}
      </div>
    </>
  );
}
